import { VaultedSecretAccess } from "@p0security/integrations-vaulted-credential-shared";
import { Access } from "@p0security/shared/types/access/index";

export const PagerdutyAiAccesses = {
  permission: Access({
    description:
      "Scopes in a PagerDuty account, granted via a shared NHI credential",
    label: "Permission",
    maturity: "beta",
    ...VaultedSecretAccess,
    parameters: {
      account: {
        type: "dynamic",
        label: "Account",
        description: "PagerDuty account",
      },
      // Values are PagerDuty OAuth scopes (e.g. "incidents.read"), limited to
      // what the Scoped OAuth app allows.
      policies: {
        type: "dynamic",
        label: "Scopes",
        description: "Authorization scopes to grant in the account",
        multivalued: true,
      },
    },
    render: {
      locator: "account",
      policy: "policies",
    } as const,
  }),
};

export type PagerdutyAiAccesses = typeof PagerdutyAiAccesses;
export type PagerdutyAiAccess = PagerdutyAiAccesses[keyof PagerdutyAiAccesses];
export type PagerdutyAiPermissionAccess = PagerdutyAiAccesses["permission"];
